import { LicenseElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class License extends LicenseElement {}
export default License;